import { render, staticRenderFns } from "./NewProjectMessage.vue?vue&type=template&id=819e1fa6&scoped=true&"
import script from "./NewProjectMessage.vue?vue&type=script&lang=js&"
export * from "./NewProjectMessage.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectMessage.vue?vue&type=style&index=0&id=819e1fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819e1fa6",
  null
  
)

export default component.exports